import { render } from "./CreateAppointmentDoctor.vue?vue&type=template&id=4f7b93ae&scoped=true"
import script from "./CreateAppointmentDoctor.vue?vue&type=script&lang=js"
export * from "./CreateAppointmentDoctor.vue?vue&type=script&lang=js"

import "./CreateAppointmentDoctor.vue?vue&type=style&index=0&id=4f7b93ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7b93ae"]])

export default __exports__